function getBreakpoint(size) {
    return getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + size).replace('px', '').trim();
}

module.exports = {
    getBreakpoint
};
